import { UserRoute, RequireOrganization } from "../components/ProtectedRoute";
import { DashboardLayout } from "../components/DashboardLayout";

export default [UserRoute, RequireOrganization, DashboardLayout];